let version = "v1.2.3";
function getUrl(path){
    return `\\${version}${path}`
}
export default {
    // 系统管理
    system: {
        // 菜单权限——菜单模块
        addOrUpdateMenu: getUrl("/auth/menu/addOrUpdateMenu"), // 添加/更新菜单信息
        deleteMenuById: getUrl("/auth/menu/deleteMenuById"), // 单条删除菜单列表
        deleteMenuByIds: getUrl("/auth/menu/deleteMenuByIds"), // 批量删除菜单列表
        queryMenuInfo: getUrl("/auth/menu/queryMenuInfo"), // 查询菜单列表
        queryMenuList: getUrl("/auth/menu/queryMenuList"), // 查询权限列表
        queryMenuByLevel: getUrl("/auth/menu/queryMenuByLevel"), // 根据层级查询菜单
        queryAuthByLevel: "/auth/auth/queryAuthByLevel", // 根据层级查询权限 get

        // 菜单权限——权限模块
        addAuth: "/auth/auth/addAuth", // 添加权限数据
        addOrUpdateAuth: "/auth/auth/addOrUpdateAuth", // 添加/更新权限信息
        deleteAuthById: "/auth/auth/deleteAuthById", // 单条删除权限列表
        deleteAuthByIds: "/auth/auth/deleteAuthByIds", // 批量删除权限列表
        queryAuthInfo: "/auth/auth/queryAuthInfo", // 查询权限详情
        queryAuthList: "/auth/auth/queryAuthList", // 查询权限列表 post
        queryAuthPageList: "/auth/auth/queryAuthPageList", // 分页查询权限列表

        // 菜单权限——角色
        addOrUpdateBaseRole: "/v1.2.4/auth/role/addOrUpdateBaseRole", // 添加系统初始角色 post
        deleteBaseRoleById: "/v1.2.4/auth/role/deleteBaseRoleById", // 单条删除权限列表 delete
        queryBaseRoleList: "/v1.2.4/auth/role/queryBaseRoleList", // 查询系统初始角色列表 get
        updateBaseRoleAuth: "/v1.2.4/auth/role/updateBaseRoleAuth", // 修改系统初始角色权限 post
        queryRoleOne: "/user/role/queryRoleOne", //  "查询单个角色" post

        // 菜单权限——权限组
        addAuthGroup: "/auth/auth/addAuthGroup", // 新增权限组 post
        deleteAuthGroupById: "/auth/auth/deleteAuthGroupById", // 删除权限组 delete
        queryAuthGroupDetail: "/auth/auth/queryAuthGroupDetail", // 查询权限组详情 post
        queryAuthGroupList: "/auth/auth/queryAuthGroupList", // 查询权限列表 get
        updateAuthGroup: "/auth/auth/updateAuthGroup", // 更新权限组 post
        queryChildrenAuth: "/auth/auth/queryChildrenAuth", // 查询权限组所有子权限 get
    }
}



// WEBPACK FOOTER //
// ./src/utils/apiList.js